export function tr(hook: any, key: string): string {
  return typeof hook(`${key}`) === "string" ? hook(`${key}`) : key;
}
